export default __webpack_public_path__ + "static/media/GasProjectGCityReport.11e9cbbd.mrt";